import { connect } from 'react-redux';
import { Field, FormProps, reduxForm } from 'redux-form';
import * as _ from 'lodash';
import * as React from 'react';

import './choose-password-form.scss';
import * as formUtils from 'login-utils/formUtils';
import AppTitleUpdater from 'login-components/Common/AppTitleUpdater';
import ErrorMessage from 'login-components/Common/Notifications/ErrorMessage/ErrorMessage';
import FormDialogFooter from 'login-components/Common/Form/FormDialog/FormDialogFooter';
import InputMap from 'login-components/Common/Inputs/InputMap';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';

export const CORE_PASSWORD_PROPERTY = 'password';
const FORM_ERROR_ID = 'ChoosePasswordForm-formError';

const inputs: FormInput[] = [
  {
    ...InputMap.PasswordInputWithStrength,
    name: CORE_PASSWORD_PROPERTY,
    identifier: 'password',
    placeholder: 'New password',
  },
  {
    ...InputMap.PasswordInput,
    name: 'password2',
    identifier: 'password again',
    placeholder: 'Repeat your new password',
    validateMatch: CORE_PASSWORD_PROPERTY,
  },
];

interface OldPasswordFormProps extends FormProps<any, any, any> {
  submitPassword: (any) => Promise<void>;
}

export class OldChoosePasswordForm extends React.Component<OldPasswordFormProps, {}> {
  render() {
    // handleSubmit always exists although typed optional
    const { handleSubmit, submitPassword, error, submitting } = this.props;
    return (
      <AppTitleUpdater text="Choose your new password">
        <form className="ChoosePasswordForm" noValidate onSubmit={handleSubmit!(submitPassword)}>
          <div className="ChoosePasswordForm-body">
            <fieldset className="ChoosePasswordForm-fieldsWrapper">
              {inputs.map(input => (
                <Field key={input.name} {...input} />
              ))}
            </fieldset>
            <div className="ChoosePasswordForm-fieldsMeta">
              {error && (
                <div className="ChoosePasswordForm-errorWrapper">
                  <ErrorMessage errorText={error} errorId={FORM_ERROR_ID} />
                </div>
              )}
            </div>
          </div>
          <FormDialogFooter>
            <PrimaryButton buttonId="it-ChoosePasswordSubmit" disabled={submitting} text="Continue" />
          </FormDialogFooter>
        </form>
      </AppTitleUpdater>
    );
  }
}

const ReduxFormConnectedChoosePasswordForm = reduxForm<any, any>({
  form: 'choosePassword',
  validate: _.partial(formUtils.validate, inputs) as () => any,
  onSubmitFail: syncErrors => formUtils.focusOnSubmitFail(syncErrors, FORM_ERROR_ID),
})(OldChoosePasswordForm);

const ConnectedChoosePasswordForm = connect()(ReduxFormConnectedChoosePasswordForm);

export default ConnectedChoosePasswordForm;
